<template>
  <div class="mb-5 pb-5">
    <div class="row mt-4">
      <div class="col">
        <Autocomplete
          label="Pipeline"
          name="pipeline"
          v-model="filters.pipeline"
          :items="pipelineList"
          classe="col-13"
          labelIcon="icon asterisk red"
          :multiple="true"
          placeholder="Selecione os pipelines"
        />
      </div>
      <div class="col">
        <Input
          label="Data Inicial"
          v-model="filters.data_ini"
          name="data_ini"
          type="date"
        />
      </div>
      <div class="col">
        <Input
          label="Data Final"
          v-model="filters.data_fim"
          name="data_fim"
          type="date"
        />
      </div>
      <div class="col" v-if="canSelectMultipleAtendentes">
        <Autocomplete
          v-model="filters.atendente"
          name="atendente"
          :items="filteredAtendenteList"
          classe="col-13"
          label="Atendente"
          :multiple="true"
          placeholder="Selecione os atendentes"
          :disabled="!canSelectMultipleAtendentes"
        />
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-2">
        <Select
          label="Origem ligação"
          name="origem_ligacao"
          v-model="filters.origem_ligacao"
          :options="origemLigacaoList"
          classe="col-13"
        />
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-2 filter-buttons">
        <button
          type="button"
          class="btn btn-success btn-sm"
          @click="filtrar"
        >
          <Icon
            type="fas"
            icon="search"
            color="white"
          />
        </button>
        <button
          type="button"
          class="btn btn-cancel btn-sm"
          @click="limpar"
        >
          <Icon
            type="fas"
            icon="times"
            title="Limpar"
          />
        </button>
      </div>
    </div>
    <div class="row mt-4" v-show="filtrou">
      <DataTable
        id="relatorio-produtividade"
        name="Relatório de Produtividade"
        :headers="headers"
        :data="filteredData"
        :pesquisa="false"
        :reorderable="true"
      />
    </div>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment';
import axios from "axios";

import Icon from '../ui/Icon.vue';
import Select from '../ui/Select.vue';
import Autocomplete from '../ui/Autocomplete.vue';
import Input from '../ui/Input.vue';
import DataTable from '../ui/DataTable.vue';

const defaultFilters = {
  pipeline: [],
  atendente: [],
  data_ini: moment().format('YYYY-MM-01'),
  data_fim: moment().format('YYYY-MM-DD'),
  origem_ligacao: { id: '', value: 'Todas' },
};

const origemLigacaoList = [
  { id: '', value: 'Todas' },
  { id: 'telefone', value: 'Telefone' },
  { id: 'whatsapp', value: 'WhatsApp' },
];

export default {
  name: 'RelatorioProdutividade',
  components: {
    Icon,
    Select,
    Autocomplete,
    Input,
    DataTable,
  },
  props: {
    userGroupId: {
      type: Number,
      default: null
    },
    statusNomes: {
      type: Object,
      default: () => ({
        em_negociacao: 'Em Negociação',
        fechou: 'Fechou',
        perdido: 'Perdido'
      })
    }
  },
  data() {
    return {
      filtrou: false,
      filters: { ...defaultFilters },
      pipelineList: [],
      atendenteList: [],
      allAtendenteList: [],
      origemLigacaoList,
      isSuper: window.super === "1" || window.super === 1,
      currentUserId: parseInt(window.userId) || null,
      data: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: 'Nome',
          value: 'nome',
          info: 'Nome do atendente/vendedor'
        },
        {
          text: 'Contatos',
          value: 'contatos',
          align: 'right',
          total: true,
          precision: 0,
          info: 'Total de clientes atendidos pelo atendente no período'
        },
        {
          text: 'Mensagens',
          value: 'mensagens',
          align: 'right',
          total: true,
          precision: 0,
          info: 'Total de mensagens enviadas pelo atendente no período'
        },
        {
          text: `${this.statusNomes.em_negociacao || 'Em Negociação'} (R$)`,
          value: 'em_negociacao',
          align: 'right',
          total: true,
          precision: 2,
          info: `Valor total das oportunidades em status "${this.statusNomes.em_negociacao || 'Em Negociação'}" no momento`
        },
        {
          text: `Orçamentos em ${this.statusNomes.em_negociacao || 'Aberto'}`,
          value: 'orcamentos_em_aberto',
          align: 'right',
          total: true,
          precision: 0,
          info: 'Total de orçamentos em aberto no momento'
        },
        {
          text: `${this.statusNomes.fechou || 'Fechou'} (R$)`,
          value: 'fechou',
          align: 'right',
          total: true,
          precision: 2,
          info: `Valor total das oportunidades fechadas com status "${this.statusNomes.fechou || 'Fechou'}" no período`
        },
        {
          text: `Orçamentos em ${this.statusNomes.fechou || 'Fechado'}`,
          value: 'orcamentos_fechados',
          align: 'right',
          total: true,
          precision: 0,
          info: 'Total de orçamentos fechados no período'
        },
        {
          text: `${this.statusNomes.perdido || 'Perdido'} (R$)`,
          value: 'perdido',
          align: 'right',
          total: true,
          precision: 2,
          info: `Valor total das oportunidades perdidas com status "${this.statusNomes.perdido || 'Perdido'}" no período`
        },
        {
          text: 'Total Produtos (R$)',
          value: 'total_produtos',
          align: 'right',
          total: true,
          precision: 2,
          info: 'Soma dos valores de produtos das oportunidades em negociação, fechadas e perdidas'
        },
        {
          text: 'Total Serviços (R$)',
          value: 'total_servicos',
          align: 'right',
          total: true,
          precision: 2,
          info: 'Soma dos valores de serviços das oportunidades em negociação, fechadas e perdidas'
        },
        {
          text: `Orçamentos em ${this.statusNomes.perdido || 'Perdido'}`,
          value: 'orcamentos_perdidos',
          align: 'right',
          total: true,
          precision: 0,
          info: 'Total de orçamentos perdidos no período'
        },
        {
          text: 'Oportunidades Em Aberto',
          value: 'oportunidades_em_aberto',
          align: 'right',
          total: true,
          precision: 0,
          info: 'Quantidade de oportunidades que estão em aberto (sem data de fechamento) no momento'
        },
        {
          text: 'Oportunidades Criadas',
          value: 'oportunidades_abertas',
          align: 'right',
          total: true,
          precision: 0,
          info: 'Quantidade total de oportunidades criadas pelo atendente no período selecionado'
        },
        {
          text: 'Oportunidades Encerradas',
          value: 'oportunidades_fechadas',
          align: 'right',
          total: true,
          precision: 0,
          info: 'Quantidade total de oportunidades encerradas (fechadas, perdidas ou finalizadas) pelo atendente no período'
        },
        {
          text: 'Tarefas Encerradas',
          value: 'tarefas_encerradas',
          align: 'right',
          total: true,
          precision: 0,
          info: 'Quantidade total de tarefas concluídas pelo atendente no período selecionado'
        },
        {
          text: 'Ligações',
          value: 'ligacoes',
          align: 'right',
          total: true,
          precision: 0,
          info: 'Quantidade total de ligações realizadas pelo atendente no período selecionado (filtro por origem quando aplicável)'
        },
        {
          text: 'TMA (min)',
          value: 'tma',
          align: 'right',
          media: true,
          precision: 0,
          info: 'Tempo médio de atendimento das oportunidades atendidas pelo atendente no período (totalizador representa a média do TMA)'
        },
      ];
    },
    filteredData() {
      return this.data.filter(item => {
        // Verifica se todos os campos numéricos são zero ou falsy
        const hasData = 
          (item.contatos && item.contatos > 0) ||
          (item.em_negociacao && item.em_negociacao > 0) ||
          (item.fechou && item.fechou > 0) ||
          (item.perdido && item.perdido > 0) ||
          (item.total_produtos && item.total_produtos > 0) ||
          (item.total_servicos && item.total_servicos > 0) ||
          (item.oportunidades_em_aberto && item.oportunidades_em_aberto > 0) ||
          (item.oportunidades_abertas && item.oportunidades_abertas > 0) ||
          (item.oportunidades_fechadas && item.oportunidades_fechadas > 0) ||
          (item.mensagens && item.mensagens > 0) ||
          (item.tarefas_encerradas && item.tarefas_encerradas > 0) ||
          (item.ligacoes && item.ligacoes > 0) ||
          (item.orcamentos && item.orcamentos > 0) ||
          (item.tma && item.tma > 0);
        
        return hasData;
      });
    },
    canSelectMultipleAtendentes() {
      // Admin (1), Gerente (2) e Super podem selecionar múltiplos atendentes
      const groupId = this.userGroupId;
      return this.isSuper || groupId === 1 || groupId === 2;
    },
    filteredAtendenteList() {
      // Se não pode selecionar múltiplos, mostra apenas o próprio usuário
      if (!this.canSelectMultipleAtendentes && this.currentUserId) {
        return this.allAtendenteList.filter(a => a.id === this.currentUserId);
      }
      return this.allAtendenteList;
    }
  },
  mounted() {
    this.getPipelines();
    this.getAtendentes();
  },
  methods: {
    getPipelines() {
      api.get('/painel/oportunidades-pipelines', { params: { data: 1 } })
        .then(response => {
          this.pipelineList = response.data.map(pipeline => ({
            id: pipeline.id,
            value: pipeline.value,
          }));
        })
        .catch(error => {
          console.error('Error fetching pipelines:', error);
        });
    },
    getAtendentes() {
      api.get('/painel/usuarios', { params: { data: 1 } })
        .then(response => {
          this.allAtendenteList = response.data.map(atendente => ({
            id: atendente.id,
            value: atendente.name,
          }));
          
          // Se não pode selecionar múltiplos atendentes, auto-seleciona o próprio usuário
          this.$nextTick(() => {
            if (!this.canSelectMultipleAtendentes && this.currentUserId) {
              const currentUser = this.filteredAtendenteList.find(a => a.id === this.currentUserId);
              if (currentUser) {
                this.filters.atendente = [currentUser];
              } else if (this.allAtendenteList.length > 0) {
                // Se não encontrar na lista filtrada, busca na lista completa
                const userFromAll = this.allAtendenteList.find(a => a.id === this.currentUserId);
                if (userFromAll) {
                  this.filters.atendente = [userFromAll];
                } else {
                  // Se não encontrar na lista, cria um objeto básico
                  this.filters.atendente = [{ id: this.currentUserId }];
                }
              }
            }
          });
        })
        .catch(error => {
          console.error('Error fetching atendentes:', error);
        });
    },
    limpar() {
      this.filters = { ...defaultFilters };
      // Se não pode selecionar múltiplos atendentes, mantém o próprio usuário selecionado
      if (!this.canSelectMultipleAtendentes && this.currentUserId) {
        const currentUser = this.filteredAtendenteList.find(a => a.id === this.currentUserId);
        if (currentUser) {
          this.filters.atendente = [currentUser];
        } else {
          this.filters.atendente = [{ id: this.currentUserId }];
        }
      }
    },
    initializeTooltips() {
      // Inicializa os tooltips do Bootstrap após o componente ser renderizado
      if (typeof $ !== 'undefined') {
        $('[data-toggle="tooltip"]').tooltip();
      }
    },
    async filtrar() {
      $("#overlayer-loading").addClass("show-overlayer");
      
      // Se não pode selecionar múltiplos atendentes, força o filtro para o próprio usuário
      let atendenteIds = [];
      if (!this.canSelectMultipleAtendentes && this.currentUserId) {
        atendenteIds = [this.currentUserId];
      } else {
        atendenteIds = this.filters.atendente.map(a => a.id);
      }
      
      const params = {
        pipeline: this.filters.pipeline.map(p => p.id),
        atendente: atendenteIds,
        data_ini: this.filters.data_ini,
        data_fim: this.filters.data_fim,
      };

      if (this.filters.origem_ligacao?.id) {
        params.origem_ligacao = this.filters.origem_ligacao.id;
      }

      await api.get('/painel/fluxo-oportunidades/produtividade/relatorio', { params })
        .then(async response => {
          if (response.data.url) {
            const retorno_url = await axios.get(response.data.url, {
              withCredentials: false,
            });
            this.data = retorno_url.data;
          } else {
            this.data = response.data.data;
          }
        })
        .catch(error => {
          let errorMessage = 'Erro ao buscar relatório de produtividade';
          if (error.response.data.message) errorMessage = error.response.data.message;
          if (error.response.data.errors) {
            Object.values(error.response.data.errors).forEach(item => {
              errorMessage = errorMessage.concat('</br>', item);
            });
          }
          window.showToastDanger('body', errorMessage);
        })
        .finally(() => {
          this.filtrou = true;
          $("#overlayer-loading").removeClass("show-overlayer");
          this.$nextTick(() => {
            this.initializeTooltips();
          });
        });
    },
  },
}
</script>
